// extracted by mini-css-extract-plugin
module.exports = {"header":"DispatchShowContainer_header__aQTHR"};